export default __webpack_public_path__ + "static/media/fa-regular-400.9c9c54c0.ttf";